import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import employeeReducer from '../features/employees/employeeSlice';
import timeentryReducer from '../features/timeentries/timeentrySlice';

export const store = configureStore({
  reducer: {
    employees: employeeReducer,
    auth: authReducer,
    entries: timeentryReducer,

  },
});


